import { Component } from 'react'
import { ReactP5Wrapper } from "react-p5-wrapper";
import sketchScroll from '../components/SketchPredeterminateScroll';

export default class Predeterminate extends Component {
    render() {
        return(
            <div className="neortCanvas">
                <ReactP5Wrapper sketch={sketchScroll}/>
            </div>
        )
    }
}